module.exports = __webpack_public_path__ + "img/shape_circle.9cb0422.webp";